import { createSlice } from "@reduxjs/toolkit";
import { checkImageType, deleteFileFromCloudinary, uploadFileToCloudinary } from "./CloudinaryThunk";

const cloudinarySlice = createSlice({
    name: 'cloudinary',
    initialState: {
        uploadStatus: 'idle',
        uploadError: null,
        uploadedFile: null,
        deleteStatus: 'idle',
        deleteError: null,
        checkImageStatus: 'idle',
        checkImageResult: null,
        checkImageError: null
    },
    reducers: {},
    extraReducers: (builder) => {
        // Upload file handling
        builder
            .addCase(uploadFileToCloudinary.pending, (state) => {
                state.uploadStatus = 'loading';
                state.uploadError = null;
            })
            .addCase(uploadFileToCloudinary.fulfilled, (state, action) => {
                console.log(action.payload ,"action.payloadaction.payload")
                state.uploadStatus = 'succeeded';
                state.uploadedFile = action.payload;
            })
            .addCase(uploadFileToCloudinary.rejected, (state, action) => {
                state.uploadStatus = 'failed';
                state.uploadError = action.payload;
            })
            // Delete file handling
            .addCase(deleteFileFromCloudinary.pending, (state) => {
                state.deleteStatus = 'loading';
                state.deleteError = null;
            })
            .addCase(deleteFileFromCloudinary.fulfilled, (state) => {
                state.deleteStatus = 'succeeded';
            })
            .addCase(deleteFileFromCloudinary.rejected, (state, action) => {
                state.deleteStatus = 'failed';
                state.deleteError = action.payload;
            })
            // Check image type handling
            .addCase(checkImageType.pending, (state) => {
                state.checkImageStatus = 'loading';
                state.checkImageError = null;
            })
            .addCase(checkImageType.fulfilled, (state, action) => {
                state.checkImageStatus = 'succeeded';
                state.checkImageResult = action.payload;
            })
            .addCase(checkImageType.rejected, (state, action) => {
                state.checkImageStatus = 'failed';
                state.checkImageError = action.payload;
            });
    }
});

export default cloudinarySlice.reducer;